import { render, staticRenderFns } from "./AttributionWindowDisclaimerModal.vue?vue&type=template&id=03c4cf2a"
import script from "./AttributionWindowDisclaimerModal.vue?vue&type=script&lang=js"
export * from "./AttributionWindowDisclaimerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports